/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContractDto } from '../../models/contract-dto';
import { SimulateContractCommand } from '../../models/simulate-contract-command';

export interface SimulateContractCommandAsync$Params {
      body?: SimulateContractCommand
}

export function simulateContractCommandAsync(http: HttpClient, rootUrl: string, params?: SimulateContractCommandAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<ContractDto>> {
  const rb = new RequestBuilder(rootUrl, simulateContractCommandAsync.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContractDto>;
    })
  );
}

simulateContractCommandAsync.PATH = '/api/simulate/contract';
